import { render } from "./ContentCreation.vue?vue&type=template&id=67283c90&scoped=true"
import script from "./ContentCreation.vue?vue&type=script&lang=js"
export * from "./ContentCreation.vue?vue&type=script&lang=js"

import "./ContentCreation.vue?vue&type=style&index=0&id=67283c90&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67283c90"]])

export default __exports__